import { render, staticRenderFns } from "./PopupEducationServiceRedirect.vue?vue&type=template&id=5b6a745e&"
import script from "./PopupEducationServiceRedirect.vue?vue&type=script&lang=js&"
export * from "./PopupEducationServiceRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports